import type {
  UserNotification,
  GalleryImage,
  Contributions,
  MainMenu,
  Teams,
} from "$types";
import { writable } from "svelte/store";
import type { Writable } from "svelte/store";
import { persisted } from "svelte-local-storage-store";

export const maxWidth = 1400;

// browser only checked
export const logging_in_spinner = writable(false);

// we will hold our notifications in a store
export const notifications: Writable<UserNotification[]> = writable([]);

export const last_comment = persisted("last_comment", "");

// color teams
export const teams: Teams[] = [
  {
    name: "Teal",
    color: "#008080",
    value: "teal",
  },
  {
    name: "Purple",
    color: "#6644FF",
    value: "purple",
  },
  {
    name: "Orange",
    color: "#FFA439",
    value: "orange",
  },
  {
    name: "Blue",
    color: "#3399FF",
    value: "blue",
  },
  {
    name: "Red",
    color: "#E35169",
    value: "red",
  },
  {
    name: "Rainbow",
    color: `linear-gradient( 68.1deg,  rgba(196,69,69,1) 9.2%, rgba(255,167,73,0.82) 25%, rgba(253,217,82,0.82) 43.4%, rgba(107,225,108,0.82) 58.2%, rgba(107,169,225,0.82) 75.1%, rgba(153,41,243,0.82) 87.3% )`,
    value: "rainbow",
  },
];

// card exchange profile store || starts as undefined
// browser only checked
export const card_exchange: Writable<{
  address?: string;
  interests?: string;
  birthday?: number;
  country?: string;
}> = writable({
  address: ``,
  interests: ``,
  birthday: 0,
  country: ``,
});

// browser checked
export const commitments = writable(0);
// browser checked
export const max_commitments = writable(3);
// browser checked
export const sent_exchanges: Writable<string[]> = writable([]);

// header & broswer checked
export const headerMax = writable(100);

// confetti && browser checked
export const show_confetti = writable(false);
// browser checked
export const how_far_to_scroll_in_gallery = writable(0);
// browser checked
export const show_post_login_confetti = writable(true);

export const gallery_sub_src = writable("");

// episode archive gallery header bar height && browser checked
export const archiveBar = writable(500);
// browser checked
export const modalActive = writable(false);
// browser checked
export const modal: Writable<GalleryImage[] | Contributions[]> = writable([]);
// browser checked
export const modalShow = writable(0);
// browser checked
export const modalEpisode = writable("");
// browser checked
export const modalSideBarWidth = writable(0);
// browser checked
export const isNavigatingNext = writable(true);
export const galleryAnimationDelay = 300;
// browser checked
export const currentImageHeight = writable(500);

// layout && browser checked
export const breakpoint = writable(1024);
// browser checked
export const mobileView = writable(false);
// browser checked
export const scrollBarWidth = writable(0);
// browser checked
export const scrollDisabled = writable(false);
// browser checked
export const headerHeight = writable(0);
// browser checked
export const header_menu_height = writable(100);
// browser checked
export const background_bar_height = writable(500);
// if browser
export const header_hiding = writable(false);

// menu data && browser checked
export const activeSection = writable("home");
// browser checked
export const menuDrawerOpen = writable(false);
// browser checked
export const patronMenuDrawerOpen = writable(false);
// browser checked
export const keyboardMode = writable(false);
// browser checked
export const tabDetected = writable(false);
// browser checked
export const focusDetected = writable(false);
// browser checked
export const focusContent = writable(false);

// import icons
import About from "$lib/components/layout/header/navigation/icons/About.svelte";
import Parameters from "$lib/components/layout/header/navigation/icons/Parameters.svelte";
import Glossary from "$lib/components/layout/header/navigation/icons/Glossary.svelte";
import Participate from "$lib/components/layout/header/navigation/icons/Participate.svelte";
import Contact from "$lib/components/layout/header/navigation/icons/Contact.svelte";
import Archive from "$lib/components/layout/header/navigation/icons/Archive.svelte";
import Upcoming from "$lib/components/layout/header/navigation/icons/Upcoming.svelte";
import Submit from "$lib/components/layout/header/navigation/icons/Submit.svelte";
import Guests from "$lib/components/layout/header/navigation/icons/Guests.svelte";
import Star from "$lib/components/layout/header/navigation/icons/Star.svelte";
import Award from "$lib/components/layout/header/navigation/icons/Award.svelte";
import Key from "$lib/components/layout/header/navigation/icons/Key.svelte";
import Box from "$lib/components/layout/header/navigation/icons/Box.svelte";
import Cog from "$lib/components/layout/header/navigation/icons/Cog.svelte";
import Envelope from "$lib/components/layout/header/navigation/icons/Envelope.svelte";
import Sponsors from "$lib/components/layout/header/navigation/icons/Sponsors.svelte";
import Image from "$lib/components/layout/header/navigation/icons/Image.svelte";
import Gift from "$lib/components/layout/header/navigation/icons/Gift.svelte";
import Fancy from "$lib/components/layout/header/navigation/icons/Fancy.svelte";
import Unlock from "$lib/components/layout/header/navigation/icons/Unlock.svelte";
import Lock from "$lib/components/layout/header/navigation/icons/Lock.svelte";
import Repeat from "$lib/components/layout/header/navigation/icons/Repeat.svelte";
import Link from "$lib/components/layout/header/navigation/icons/Link.svelte";

export const menu: MainMenu[] = [
  {
    text: "Episodes",
    section: "episodes",
    loggedInSub: [],
    sub: [
      {
        hover: false,
        href: "/episodes",
        text: "Episode Archive",
        title: "A library of past Craft Roulette episodes.",
        component: Archive,
      },
      {
        hover: false,
        href: "/events",
        text: "Special Events",
        title: "You don't want to miss out!",
        component: Award,
      },
      {
        hover: false,
        href: "/episodes/upcoming",
        text: "Upcoming Episodes",
        title: "Scheduled Craft Roulette episodes.",
        component: Upcoming,
      },
      {
        hover: false,
        href: "/submit",
        text: "Submit A Contribution",
        title: "Submit a contribution to the current challenge.",
        component: Submit,
      },
    ],
  },
  {
    text: "Resources",
    section: "show",
    loggedInSub: [],
    sub: [
      {
        hover: false,
        href: "/creative-companion",
        text: "Creative Companion",
        title: "A tool to help you with your Craft Roulette creations.",
        component: Star,
      },
      {
        hover: false,
        href: "https://paperganza.com",
        text: "Paperganza",
        external: true,
        title: "Craft Roulette's live event series.",
        component: Star,
      },
      {
        hover: false,
        href: "/shop",
        text: "Official Shop",
        title:
          "Support the show by purchasing official Craft Roulette products.",
        component: Sponsors,
      },
      {
        hover: false,
        href: "/show",
        text: "Craft Roulette",
        title: "Learn about Craft Roulette and the people behind it.",
        component: About,
        sub: [
          {
            hover: false,
            href: "/show/parameters",
            text: "On The Wheel",
            title: "See the current parameter configuration.",
            component: Parameters,
          },
          {
            hover: false,
            href: "/episodes/schedule",
            text: "Weekly Schedule",
            title: "A timezone aware calendar of our content release schedule.",
            component: Repeat,
          },
          {
            hover: false,
            href: "/show",
            text: "About The Show",
            title: "Learn about Craft Roulette and the people behind it.",
            component: About,
          },

          {
            hover: false,
            href: "/in-revue",
            text: "In Revue",
            title: "The follow-up show for Craft Roulette.",
            component: Fancy,
          },
          {
            hover: false,
            href: "/show/glossary",
            text: "Glossary & Concepts",
            title: "The details and terms that are used in the show.",
            component: Glossary,
          },
          {
            hover: false,
            href: "/show/participate",
            text: "How to Participate",
            title: "How to participate in the Craft Roulette community.",
            component: Participate,
          },
        ],
      },
      {
        hover: false,
        href: "/contact",
        text: "Contact & Prize Claim",
        title: "Get in touch or send us snail mail!",
        component: Contact,
        sub: [
          {
            href: "/contact",
            text: "Contact",
            title: "Get in touch or send us snail mail!",
            component: Contact,
          },
          {
            href: "/claim",
            text: "Claim A Prize",
            title: "Claim a prize from our give aways.",
            component: Gift,
          },
          {
            href: "/email",
            text: "Email List",
            title: "Subscribe to, or unsubscribe from our email list.",
            component: Star,
          },
        ],
      },
    ],
  },
  {
    text: "Associates",
    section: "guests",
    loggedInSub: [],
    sub: [
      {
        hover: false,
        href: "/guests",
        text: "Guest Crafters",
        title: "View all of our featured Guest Crafters from Craft Roulette.",
        component: Guests,
      },
      {
        hover: false,
        href: "/sponsors",
        text: "Spin Sponsors",
        title: "The companies that sponsor our give-aways.",
        component: Sponsors,
      },
      {
        hover: false,
        href: "/community",
        text: "Community",
        title: "Member profiles and content they have created.",
        component: Guests,
        sub: [
          {
            hover: false,
            href: "/community",
            text: "Community Showcase",
            title:
              "Check out the amazing members of our community and their profiles.",
            component: Guests,
          },
          {
            hover: false,
            href: "/community/process-videos",
            text: "Process Videos",
            title:
              "Process videos from our members based on Craft Roulette challenges.",
            component: Archive,
          },
          {
            hover: false,
            href: "/community/galleries",
            text: "Curated Galleries",
            title: "Contribution galleries curated by our Members.",
            component: Image,
          },
        ],
      },
    ],
  },
  {
    text: "Memberships",
    loggedInText: "Member Content",
    section: "extras",
    loggedInHref: "/members",
    loggedInSub: [
      {
        hover: false,
        href: "/support",
        loggedInHref: "/members",
        text: "Become A Member",
        title: "Unlock all these & more!",
        loggedInText: "Member Dashboard",
        loggedInTitle: "All of your membership features.",
        component: Unlock,
        loggedInComponent: Cog,
        superhighlight: true,
      },
      {
        hover: false,
        href: "/members/help",
        text: "Get Help",
        title: "Get help with your account, or ask questions about the site.",
        component: Link,
      },
    ],
    sub: [
      {
        hover: false,
        href: "/support",
        loggedInHref: "/members",
        text: "Support our Efforts",
        title:
          "Learn how to support us as a member and unlock tons of Extra features on this site!",
        loggedInText: "Dashboard",
        loggedInTitle: "Home base for logged in users.",
        component: Unlock,
        override_arrows: false,
        loggedInComponent: Cog,
        sub: [
          {
            hover: false,
            href: "/support",
            loggedInHref: "/members",
            text: "Become A Member",
            title: "Unlock all these & more!",
            loggedInText: "Dashboard",
            loggedInTitle: "Logged in home base.",
            component: Unlock,
            loggedInComponent: Cog,
            superhighlight: true,
          },
          {
            hover: false,
            href: "/members/challenge",
            text: "Bonus Challenge",
            title: "A new challenge every week with a 5th parameter!",
            component: Lock,
            loggedInComponent: Award,
            auth_required: true,
          },
          {
            hover: false,
            href: "/members/parameters",
            text: "Parameter Vault",
            title: "All parameters in our system and their stats.",
            component: Lock,
            loggedInComponent: Key,
            auth_required: true,
          },
          {
            hover: false,
            href: "/members/contributions",
            text: "Contribution Explorer",
            title:
              "Search our contribution library and create custom galleries.",
            component: Lock,
            loggedInComponent: Box,
            auth_required: true,
          },
          {
            href: "/members/galleries",
            text: "Create A Gallery",
            loggedInText: "Gallery Manager",
            title: "Create and edit your own curated galleries.",
            component: Lock,
            loggedInComponent: Image,
            auth_required: true,
          },
          {
            hover: false,
            href: "/members/exchange",
            text: "Card Exchange",
            title: "Connect with our community to send and receive cards.",
            component: Lock,
            loggedInComponent: Envelope,
            auth_required: true,
          },
          {
            href: "/members/downloads",
            text: "Digital Downloads",
            title: "Mary Gunn original art to download and print.",
            component: Lock,
            loggedInComponent: Image,
            auth_required: true,
          },
        ],
      },
      {
        hover: false,
        href: "/login/register",
        text: "Register Account",
        title: "Create your account and setup your subscription.",
        component: Star,
      },
    ],
  },
];

// secret & checked
export const ellen: Writable<boolean> = writable(false);
// browser checked
export const activeColor = writable(0);
export const colors = [
  {
    color: "#58ccaf",
    highlight: "#5ea1bb",
  },
  {
    // resources
    color: "#fb8b24",
    highlight: "#7dafa0",
  },
  {
    color: "#ff77aa",
    highlight: "#7e7cef",
  },
  {
    // currently extras
    color: "#ed696d",
    highlight: "#545fae",
  },
  {
    color: "#b190cd",
    highlight: "#528dd9",
  },
  {
    color: "#5A95F0",
    highlight: "#325189",
  },
];

// browser checked
export const schedule_slide = writable(0);
// browser checked
export const schedule_height = writable(0);
